import { useTranslation } from 'react-i18next'

import { RankingBarsPlot } from '@digital-twins/deck-ui/plots/ranking-bars'
import { formatLabel } from '@/lib/utils/formatting'
import { useRankingBarsLabels } from '@/features/studies/report/page/components/views/analysis/useRankingBarsLabels'

import { FigurePanelSections, FigureViewProps } from './figureViewShared'

import { RankData } from '@digital-twins/slide-schemas/generated/plot-types'

/**
 * `ranking-bars` on the survey tab (plots plan I): the kind's own plot
 * component at its card size, the one the summary card and quick-study draw.
 * Shape only: values, dense ranks, the winner, the tie, the decimals and the
 * scale are Python's; the items are drawn in the order Python sent them. The
 * chrome is in the viewer's UI language (owner decision 5). Item names print
 * as stamped; `isLegacy` (an analyst chart stored before its plot) keeps
 * today's `formatLabel` recasing (Wave 7 S4).
 */
export function RankingBarsFigure(props: FigureViewProps) {
  const { panels, isCut, isLegacy = false } = props

  const { t } = useTranslation('app')
  const labels = useRankingBarsLabels()

  return (
    <div data-testid="figure-ranking-bars">
      <FigurePanelSections
        panels={panels}
        isCut={isCut}
        testIdPrefix="figure-ranking-bars"
        renderPanel={(panel, index) => {
          const data = panel.plot.data as unknown as RankData
          return (
            <RankingBarsPlot
              data={{ ...data, labels: { ...data.labels, ...labels } }}
              size="card"
              // No stamped winner (an analyst chart stored before the plot): every bar primary.
              highlight={data.topIds?.length ? 'top' : 'none'}
              // Stamped names print as Python wrote them; only a legacy read keeps today's recasing.
              formatItemLabel={isLegacy ? formatLabel : undefined}
              emptyLabel={t('studyReport.noRankingData')}
              testIdPrefix={isCut ? `figure-ranking-bars-group-${index}-plot` : 'figure-ranking-bars-plot'}
            />
          )
        }}
      />
    </div>
  )
}
